module.exports = __webpack_public_path__ + "img/cmap.b05e48d3.png";